<template>
  <div class="container">
    <div class="mt-5 mb-3 text-center">
      <h3 class="mb-3">Cases</h3>
      <BootstrapIcon
        class="add-btn primary"
        icon="plus-circle"
        @click="showModal"
      />
    </div>

    <!-- #Item To Show Selector -->
    <div class="mb-5 item-amount-select">
      <p>#Item to show:</p>
      <select
        class="form-select"
        aria-label="Default select"
        v-model="itemToShow"
        @change="getData"
      >
        <option value="3">3</option>
        <option value="5">5</option>
        <option value="10">10</option>
      </select>
    </div>

    <table class="table table-hover table-striped table-bordered align-middle">
      <caption>
        Case List
      </caption>
      <thead>
        <tr>
          <th scope="col">Preview</th>
          <th scope="col">Title EN</th>
          <th scope="col">Title CH</th>
          <th scope="col">Description EN</th>
          <th scope="col">Description CH</th>
          <th scope="col">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="c._id" v-for="c in data">
          <AdminCaseTable :c="c" />
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page" class="text-center">
      <ul class="pagination">
        <li class="page-item">
          <a class="page-link" @click="lastPage" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li>
          <p>Current Page: {{ page + 1 }}</p>
        </li>
        <li class="page-item">
          <a class="page-link" @click="nextPage" aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <ModalCase v-if="displayModal" @close-modal-case="hideModal" />
</template>
<script>
// import { onMounted, computed } from "vue";
// import store from "../../store";
import axios from "axios";
import ModalCase from "./ModalCase.vue";
import AdminCaseTable from "./AdminCaseTable.vue";
export default {
  name: "AdminCase",
  components: {
    ModalCase,
    AdminCaseTable,
  },
  data() {
    return {
      data: "",
      displayModal: false,
      page: 0,
      itemToShow: 5,
    };
  },
  computed: {
    itemAmount() {
      return this.itemToShow;
    },
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
    nextPage() {
      if (this.data.length === this.itemAmount) this.page++;
      this.getData();
    },
    lastPage() {
      if (this.page > 0) {
        this.page--;
        this.getData();
      }
    },
    getData() {
      axios
        .get(
          this.$webDomain +
            "/gardenInit/GardenCase?size=" +
            this.itemAmount +
            "page=" +
            this.page
        )
        .then((response) => {
          this.data = response.data.data;
        });
    },
  },
  created() {
    this.getData();
  },
  // setup() {
  //   onMounted(() => {
  //     store.dispatch("fetchGardenCaseData");
  //   });

  //   const caseData = computed(() => store.state.gardenCaseData);
  //   return {
  //     caseData,
  //   };
  // },
};
</script>

<style scoped>
nav ul {
  display: inline-block;
}
nav li {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}

.page-link {
  cursor: pointer;
}

.item-amount-select select {
  width: 100px;
}
</style>
